'use client';

import React, {type FC} from 'react';
import {LayoutPlatform} from '@/_application/themes/kidsplaza-spring/layouts/components/layout-platform';
import {type AppLayoutProps} from '@/_application/core/types';

export const HomeLayoutClient: FC<AppLayoutProps> = ({children, layoutData, isMobile = true}) => {
    return (
        <LayoutPlatform isMobile={isMobile} variables={layoutData}>
            {children}
        </LayoutPlatform>
    );
};
